var map = {
	"./address_image.svg": 3906,
	"./blogs_image.svg": 7245,
	"./cg_img.png": 6408,
	"./confidential.jpg": 4696,
	"./deeplearning_ai_logo.png": 9575,
	"./experience.svg": 7480,
	"./feng1.png": 3179,
	"./feng_photo.png": 4845,
	"./gempoll_logo.svg": 2032,
	"./huawei.png": 4409,
	"./kaust-logo.png": 4858,
	"./nus_logo.png": 5818,
	"./projects_image.svg": 1240,
	"./sustech.png": 4883
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9420;